import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-card-price',
  templateUrl: './card-price.component.html',
  styleUrls: ['./card-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardPriceComponent {
  @Input()
  public price: number | undefined;

  @Input()
  public discount?: number;

  @Input()
  public isExactPrice: boolean;

  @Input()
  public loaderColorVariant: 'default' | 'alternative' = 'default';
}
